import { PropsWithChildren, useEffect } from 'react';

import { LDProvider, useLDClient } from 'launchdarkly-react-client-sdk';
import type { LDMultiKindContext, LDSingleKindContext } from 'launchdarkly-js-client-sdk';

const anonymousUserContext: LDSingleKindContext = {
  kind: 'user',
  anonymous: true,
};

const CustomLDProvider = ({
  children,
  clientId,
}: PropsWithChildren<{ clientId?: string }>) => {
  const context = anonymousUserContext;

  return clientId ? (
    <LDProvider context={context} clientSideID={clientId} deferInitialization>
      {children}
    </LDProvider>
  ) : (
    <>{children}</>
  );
};

export default CustomLDProvider;

export const useLDIdentify = (context?: LDMultiKindContext | LDSingleKindContext) => {

  const ldClient = useLDClient();
  const ldContext = ldClient?.getContext() as LDSingleKindContext | LDMultiKindContext;
  useEffect(() => {
    if (ldContext?.kind !== 'multi' || ldContext?.user.key !== context?.user.key) {
      if (context?.user) {
        ldClient?.identify(context);
      } else {
        ldClient?.identify({ anonymous: true });
      }
    }
  }, [context, ldClient, ldContext]);
};
